<p-input-number
  [fluid]="true"
  [formControl]="formControl"
  [showButtons]="true"
  [min]="1"
  buttonLayout="horizontal"
  inputStyleClass="w-16 text-center">
  <ng-template #incrementbuttonicon>
    <app-icon [icon]="Icon.Plus_LG" />
  </ng-template>

  <ng-template #decrementbuttonicon>
    <app-icon [icon]="Icon.Dash_LG" />
  </ng-template>
</p-input-number>
